import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 1h7a1 1 0 0 1 1 1v10H7.828A3 3 0 0 0 3 10.762V9H2v4a3 3 0 0 0 6 0h4a3 3 0 0 0 6 0h1.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5H19V7.369c0-.36-.128-.703-.363-.975l-2.459-2.869A1.5 1.5 0 0 0 15.041 3H13V2c0-1.103-.897-2-2-2H4C2.897 0 2 .897 2 2v1H.5c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5S7.775 3 7.5 3H3V2a1 1 0 0 1 1-1m13.84 6H13V4h2.04a.49.49 0 0 1 .379.175zM13 8h5v4h-.172A3 3 0 0 0 13 10.762zM3 13a2 2 0 1 1 4 0 2 2 0 0 1-4 0m12-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4M1.5 5c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5S8.775 5 8.5 5zm-1 2c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5S7.775 7 7.5 7z" }, null, -1)
  ])))
}
export default { render: render }